export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_NA-hi-IN.5c381d59.xlsx";